<div>
  <table mat-table
    [dataSource]="dataSource" multiTemplateDataRows
    class="mat-elevation-z8 qtable-my-requests">
    @for (column of columnsToDisplay; track column; let i = $index) {
      <ng-container matColumnDef="{{column}}">
        <th mat-header-cell *matHeaderCellDef> {{column | translate}} </th>
        <td mat-cell *matCellDef="let row">
          @if (i === 0) {
            <button mat-icon-button (click)="onArrowClick(row, $event)" class="expand-btn">
              <mat-icon [@rotateArrow]="row === expandedRow ? 'expanded' : 'collapsed'">
                expand_more
              </mat-icon>
            </button>
            {{formatDateTime(row[column], 'GLOBAL_DATE_FORMAT' | translate)}}
          }
          @if (i === 1) {
            {{row[column]}}
          }
          @if (i === 2) {
            <mat-icon class="{{row.TABLE_FLOW_STATUS !== SigningFlowStatus.COMPLETED ? 'my-request-status-icon' : 'my-request-status-completed-icon'}}">
              person
            </mat-icon>
            {{getNumberOfSignedSlashTotal(row)}}
            <!-- <mat-icon *ngIf="!isFlowInProgress(row)" [ngClass]="(row['TABLE_FLOW_STATUS'] === SigningFlowStatus.EXPIRED || row['TABLE_FLOW_STATUS'] === SigningFlowStatus.CANCELLED) ? 'icon-declined' : row['TABLE_FLOW_STATUS'] === SigningFlowStatus.COMPLETED ? 'icon-signed' : 'icon-pending'">
            {{getIconBasedOnSigningFlowStatus(row['TABLE_FLOW_STATUS'])}}
            </mat-icon> -->
          }
          @if (i === 3) {
            @if (displayCancelButton(row)) {
              <button class="table-button" (click)="onCancelSigningFlow(row.TABLE_FLOW_REFERENCE_CODE, $event)">
                {{'MY_REQUESTS_PAGE_CANCEL_BUTTON' | translate}}
              </button>
            }
            @if (row.TABLE_FLOW_STATUS === SigningFlowStatus.CANCELLED) {
              <p class="text-declined">
                {{'MY_REQUESTS_PAGE_FLOW_CANCELLED' | translate}}
              </p>
            }
            @if (row.TABLE_FLOW_STATUS === SigningFlowStatus.EXPIRED) {
              <p class="text-declined">
                {{'MY_REQUESTS_PAGE_FLOW_EXPIRED' | translate}}
              </p>
            }
            @if (row.TABLE_FLOW_STATUS === SigningFlowStatus.COMPLETED) {
              <p class="text-completed">
                {{'MY_REQUESTS_PAGE_FLOW_COMPLETED' | translate}}
              </p>
            }
            <button mat-icon-button (click)="onDownloadFile(row.TABLE_FLOW_REFERENCE_CODE, $event)" class="download-btn">
              <mat-icon class="my-request-download-file-icon">
                download
              </mat-icon>
            </button>
          }
        </td>
      </ng-container>
    }
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="columnsToDisplay.length">
        <div class="qtable-element-detail"
          [@detailExpand]="expandedRow === row ? 'expanded' : 'collapsed'">

          <table mat-table
            [dataSource]="getInnerDataSource(row.TABLE_SIGNER_DETAILS)" multiTemplateDataRows
            class="mat-elevation-z8">
            @for (column of innerColumnsToDisplay; track column; let i = $index) {
              <ng-container matColumnDef="{{column}}">
                <th mat-header-cell *matHeaderCellDef> {{column | translate}} </th>
                <td mat-cell *matCellDef="let innerTableRow">
                  @if (i===0) {
                    {{innerTableRow[column]}}
                  }
                  @if (i === innerColumnsToDisplay.length - 3) {
                    <mat-icon [ngClass]="(innerTableRow[column] === SigningTaskStatus.FAILED || innerTableRow[column] === SigningTaskStatus.DECLINED) ? 'icon-declined' : innerTableRow[column] === SigningTaskStatus.COMPLETED ? 'icon-signed' : 'icon-pending'">
                      {{getIconBasedOnSigningTaskStatus(innerTableRow[column])}}
                    </mat-icon>
                    {{getLabelBasedOnSigningTaskStatus(innerTableRow[column])}}
                  }
                  @if (i === innerColumnsToDisplay.length - 2) {
                    @if (displaySignByMeOption(innerTableRow) && displayResendUndescoreText(row, innerTableRow)) {
                      <span (click)="onRouteToSigningTask(innerTableRow.TABLE_TASK_REFERENCE_CODE)" class="link-like">{{'MY_REQUESTS_PAGE_ROUTE_TO_SIGNING_TASK_BUTTON' | translate}}</span>
                    }
                    @if (!displaySignByMeOption(innerTableRow) && displayResendUndescoreText(row, innerTableRow)) {
                      <span (click)="onResendRequest(innerTableRow['TABLE_TASK_REFERENCE_CODE'], $event)" class="link-like">{{'MY_REQUESTS_PAGE_RESEND_SIGNING_REQUEST_BUTTON' | translate}}</span>
                    }
                  }
                </td>
              </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="innerColumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let innerTableRow; columns: innerColumnsToDisplay;"
              class="qtable-element-row">
            </tr>
          </table>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"
      class="qtable-element-row"
      [class.qtable-expanded-row]="expandedRow === row"
      (click)="expandRow(row)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="qtable-detail-row"></tr>
  </table>

  <mat-paginator 
    [length]="totalItems"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize" 
    [pageSizeOptions]="[5, 10, 20, 50]" 
    (page)="onPageChange($event)" 
    >
  </mat-paginator>
</div>